import { useSound } from './useSound.hook';

/**
 * A hook for playing loss sound effects
 * @param options Optional configuration options for the sound
 * @returns An object with functions to control the loss sound
 */
export const useLossSound = (options?: {
  volume?: number;
  interrupt?: boolean;
  playbackRate?: number;
}) => {
  return useSound('loss', {
    volume: options?.volume ?? 0.15, // Moderate volume for loss feedback
    interrupt: options?.interrupt ?? true, // Allow interrupting previous loss sounds
    playbackRate: options?.playbackRate ?? 1,
    keepSoundAlive: true,
  });
};
